if (!customElements.get('pmu-editorial-navigation')) {
  customElements.define('pmu-editorial-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.desktop = window.matchMedia('(min-width:990px)');
      this.hover = window.matchMedia('(hover:hover) and (pointer:fine)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion:reduce)');
      this.details = this.querySelector('.pmu-products-details');
      this.trigger = this.querySelector('.pmu-products-trigger');
      this.mobileToggle = this.querySelector('.pmu-mobile-toggle');
      const signal = this.abort.signal;
      this.details.addEventListener('pointerenter', () => {
        if (this.desktop.matches && this.hover.matches) this.openProducts();
      }, { signal });
      this.details.addEventListener('pointerleave', () => {
        if (this.desktop.matches && this.hover.matches) {
          this.leaveTimer = setTimeout(() => this.closeProducts(), 180);
        }
      }, { signal });
      this.details.addEventListener('toggle', () => {
        this.trigger.setAttribute('aria-expanded', String(this.details.open));
      }, { signal });
      this.trigger.addEventListener('click', event => {
        if (this.desktop.matches && this.hover.matches && event.detail > 0) {
          event.preventDefault();
          this.openProducts();
          return;
        }
        if (!this.details.open) return;
        event.preventDefault();
        this.closeProducts();
      }, { signal });
      this.addEventListener('focusout', event => {
        if (this.desktop.matches && !this.contains(event.relatedTarget)) this.closeProducts();
      }, { signal });
      this.mobileToggle.addEventListener('click', () => {
        this.setMobileOpen(!this.classList.contains('is-mobile-open'));
      }, { signal });
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) {
          this.closeProducts();
          this.setMobileOpen(false);
        }
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeProducts();
          if (this.desktop.matches) this.trigger.focus();
          else { this.setMobileOpen(false); this.mobileToggle.focus(); }
        }
      }, { signal });
      this.desktop.addEventListener('change', () => {
        this.setMobileOpen(false);
        this.closeProducts(true);
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        if (!this.desktop.matches) this.setMobileOpen(true);
        this.openProducts();
      }, { signal });
    }
    openProducts() {
      clearTimeout(this.leaveTimer);
      clearTimeout(this.closeTimer);
      this.details.classList.remove('pmu-closing');
      this.details.open = true;
      this.trigger.setAttribute('aria-expanded', 'true');
    }
    closeProducts(immediate = false) {
      clearTimeout(this.leaveTimer);
      clearTimeout(this.closeTimer);
      if (!this.details.open) return;
      if (immediate || this.reducedMotion.matches) {
        this.details.open = false;
        this.details.classList.remove('pmu-closing');
        this.trigger.setAttribute('aria-expanded', 'false');
        return;
      }
      this.details.classList.add('pmu-closing');
      this.closeTimer = setTimeout(() => {
        this.details.open = false;
        this.details.classList.remove('pmu-closing');
        this.trigger.setAttribute('aria-expanded', 'false');
      }, 180);
    }
    setMobileOpen(open) {
      this.classList.toggle('is-mobile-open', open);
      this.mobileToggle.setAttribute('aria-expanded', String(open));
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearTimeout(this.leaveTimer);
      clearTimeout(this.closeTimer);
    }
  });
}
